export const exchange_es_AR: any = {
    title_exchange: 'Pasar {{element_one}} a {{element_two}}',
    subtitle_exchange: 'Es muy simple',
    step_one_exchange: 'Cotizas y haces tu pedido',
    step_two_exchange: 'Recibes las instrucciones para hacer tu envío',
    step_three_exchange: 'Te enviamos tus {{element}} cotizados',
    titleExchange: 'Cotización de {{element}} a lo largo del tiempo'
};
